
import Vue from 'vue'
import axios from 'axios'
import { Component } from 'vue-property-decorator'
import { Dispute } from '../../global/models'
import DisputeDetail from '../components/DisputeDetail.vue'
import DisputeMessages from '../components/DisputeMessages/index.vue'

@Component({
  components: { DisputeDetail, DisputeMessages }
})
export default class DisputeReadPage extends Vue {
  tab: string | null = null

  dispute: Dispute | null = null

  error: string | null = null

  get disputeId() {
    return this.$route.params.id
  }

  get canAcceptOrReject() {
    return this.dispute?.raisedBy === 'customer'
  }

  mounted() {
    this.getData()
  }

  async getData() {
    try {
      const response = await axios.get<Dispute>(`disputes/${this.disputeId}`)
      this.dispute = response.data
    } catch (error) {
      if (error.response.status === 403) {
        this.error = 'unauthorised'
      } else if (error.response.status === 404) {
        this.error = 'not-found'
      } else {
        this.error = 'generic'
      }
    }
  }

  async resolveDispute() {
    try {
      await axios.post(`disputes/${this.disputeId}/resolve`)
      this.$store.dispatch('success', 'Status updated')
      this.getData()
    } catch (error) {
      this.$store.dispatch('error', error.response.data)
    }
  }

  async requestAdjudication() {
    try {
      await axios.post(`disputes/${this.disputeId}/request-adjudication`)
      this.$store.dispatch('success', 'Status updated')
      this.getData()
    } catch (error) {
      this.$store.dispatch('error', error.response.data)
    }
  }
}
